import { render, staticRenderFns } from "./ToDoApplicationComponent.vue?vue&type=template&id=2f08e7d2&scoped=true"
import script from "./ToDoApplicationComponent.vue?vue&type=script&lang=ts"
export * from "./ToDoApplicationComponent.vue?vue&type=script&lang=ts"
import style0 from "./ToDoApplicationComponent.vue?vue&type=style&index=0&id=2f08e7d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f08e7d2",
  null
  
)

export default component.exports